import React from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { StyleSheet, TouchableOpacity } from 'react-native';

import { Icon, theme } from '@sg/garnish';

// ─────────────────────────────────────────────────────────────────────────────

export const LoyaltyHomeScanButton = (props: Props) => {
  const { onPress } = props;
  const { formatMessage } = useIntl();

  return (
    <TouchableOpacity
      style={styles.container}
      accessibilityLabel={formatMessage(messages.accessibilityLabel)}
      accessibilityRole="button"
      onPress={onPress}
    >
      <Icon name="IconScan" color={theme.colors.KALE} />
    </TouchableOpacity>
  );
};

// ─── Messages ────────────────────────────────────────────────────────────────

const messages = defineMessages({
  accessibilityLabel: {
    defaultMessage: 'Navigate to scan to pay screen',
    description: 'Loyalty Home | Scan Button | Accessibility Label',
  },
});

// ─── Constants ───────────────────────────────────────────────────────────────

const BUTTON_SIZE = 48;

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  container: {
    alignItems: 'center',
    justifyContent: 'center',
    width: BUTTON_SIZE,
    height: BUTTON_SIZE,
    borderRadius: BUTTON_SIZE,
    backgroundColor: theme.colors.OPACITY.KALE.LIGHTEST,
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type Props = {
  onPress: () => void;
};
